import { gql } from '@apollo/client'

export const CREATE_PAYMENT_MUTATION = gql`
  mutation createPayment($attributes: PaymentInput!) {
    createPayment(attributes: $attributes) {
      amount
      email
      status
    }
  }
`
